var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-center" },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", width: "300" },
          model: {
            value: _vm.InfoAlert,
            callback: function($$v) {
              _vm.InfoAlert = $$v
            },
            expression: "InfoAlert"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline grey lighten-2" }, [
                _vm._v(" " + _vm._s(_vm.InfoAlertTitle) + " ")
              ]),
              _c("v-card-text", [
                _vm._v(" " + _vm._s(_vm.InfoAlertMessage) + " ")
              ]),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", text: "" },
                      on: { click: _vm.emitInfoAlertOkClicked }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("infoAlert.ok")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }